import React, { createContext, useEffect, useReducer } from 'react';
import { scrollableHandlers, scrollableInitialState, scrollableReducer } from '../reducers/ScrollableReducer';

const _useScroll = false

export const ScrollableContext = createContext();

const ScrollableProvider = (props) => {

  // isMobileDevice, homeAppUrls, weatherZip
  const init_state = {}
  const [scrollable_state, scrollable_dispatch] = useReducer(scrollableReducer, scrollableInitialState(init_state));
  const scrollable_handlers = scrollableHandlers(scrollable_dispatch, scrollable_state)

  const { selectedParentRef, selectedElemRef } = scrollable_state ?? {}

  useEffect(() => {
    if (_useScroll) {
      if (selectedParentRef && selectedElemRef && selectedElemRef.current) {
        const parent = selectedParentRef.current;
        const element = selectedElemRef.current;
        const elementOffset = element.offsetTop - parent.offsetTop;
        try {
          parent.scrollTo({
            top: elementOffset,
            behavior: "instant",
          });
          // selectedElemRef.current.scrollIntoView({ behavior: "instant", block: "start" });
        } catch (error) {
          console.log('e', error)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [selectedParentRef, selectedElemRef]);


  const scrollableProvider = () => <ScrollableContext.Provider value={{ scrollable_state, scrollable_handlers }}>
    {props.children}
  </ScrollableContext.Provider>

  return scrollableProvider()
};

export default ScrollableProvider 